import { the_user } from '../me/login';
import { $api } from '../y/api';
import { YId, YTimeString } from '../y/types';
import { CBookingId, CBookingPartId } from './c-booking';

export interface MInboxItemBase {
    id: YId;
    communication_id?: YId;
    publish_at: YTimeString;
    seen_at?: YTimeString;
    created_at: YTimeString;
}

export interface MInboxRateEventItem extends MInboxItemBase {
    kind: 'rate_event';
    data: {
        event_name: string;
        event_picture: YId;
        booking_id?: CBookingId;
        video_view_id?: YId;
    }
}

export interface MInboxStandbyReservedItem extends MInboxItemBase {
    kind: 'standby_reserved';
    data: {
        event_name: string;
        event_picture: YId;
        booking_part_id: CBookingPartId;
        booking_expires: YTimeString;
        session_time: YTimeString;
    }
}

export interface MInboxCustomItem extends MInboxItemBase {
    kind: 'custom';
    data: {
        content: string;
    }
}

export type MInboxItem = MInboxRateEventItem | MInboxStandbyReservedItem | MInboxCustomItem;

export function mInboxSeen(id: YId) {
    return $api.POST(`user/${the_user!.id}/inbox/${id}/seen`);
}

